import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as net from "../../../../lib/net";
import Dd_Sel from "../../../../lib/ui/dd_sel";
import Td_Sel from "../../../../lib/ui/td_sel";
import Pay_Wnd from "./pay_wnd";
import Pay_Emv from "./pay_emv";
import Pay_Pres from "./pay_pres";
import Pay_Fsk from "./pay_fsk";

class Pay_Sel extends React.Component {
  constructor(props, context) {
    super(props);

     this.selitems = [
        {fkn: 'setup', text: 'INSTÄLLNINGAR'},
        {fkn: 'upd', text: 'UPPDATERA'},
        {fkn: 'sys', text: 'SYSTEM'},
        {fkn: 'logout', text: 'LOGGA UT'}
    ];

    this.fkn_close = null;
    this.state = {};
    this.state.ynq = [];

    this.state.paa = [];
    this.state.aa = [];
    this.state.selrow = {};
    this.state.srow = {};
    this.state.wnds = {};

    this.state.lang = "se";
    this.state.boknr = "";
    this.state.rvo = {};
    this.state.nta = [];
    if(props.wnds) {
        this.fkn_close = props.wnds.fkn_close;
        this.state.boknr = props.wnds.boknr;
        this.state.rvo = props.wnds.rvo;
        this.state.nta = props.wnds.nta;
        this.state.srow = props.wnds.srow;
    }

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.dts = dts;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.syncTb("payrowsTable")
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close() {
      if(this.fkn_close) this.fkn_close(this.props.ctx);
      else this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      //css.height = window.innerHeight - 275;
      css.overflow = "auto";
      return css;
  }
  row_style(row) {
    var srow = this.state.srow;
    var css = {};
    if(srow[row.etr01.e0lopnr]) {
        css.background = "#080";
        css.color = "#fff";
    }
    return css;
  }
  clear() {
    this.setState({srow: {}});
  }
  set_all() {
    var srow = this.state.srow;
    for(var row of this.state.nta) {
        srow[row.etr01.e0lopnr] = row;
    }
    this.setState({srow: srow});
  }
  sel_row(row) {
    var srow = this.state.srow;

    if(srow[row.etr01.e0lopnr]) {
      delete( srow[row.etr01.e0lopnr] );
    }
    else srow[row.etr01.e0lopnr] = row;
    this.setState({srow: srow});
  }
  pay_trs(betkod) {
    var self = this;

    var nta = this.state.nta;
    if(Object.keys(this.state.srow).length > 0) {
        nta = Object.values(this.state.srow);
    }

    var bettxt = "BET: " + betkod;
    if(betkod == "kont") bettxt = "KONTANT";
    if(betkod == "fakt") bettxt = "FAKTURA";
    if(betkod == "swis") bettxt = "SWISH";
    if(betkod == "Rpri") bettxt = "PRESENTKORT";
    if(betkod == "fskU") bettxt = "FÖRSKOTT UTNYTTJA";
    if(betkod == "card") bettxt = "KORT EXTERN";

    if(betkod == "emv") {
        this.pay_emv();
        return;
    }
      if(betkod == "pres") {
          return;
      }
      if(betkod == "Rpri") {
          this.pay_pres();
          return;
      }
      if(betkod == "fskU") {
          this.pay_fsk();
          return;
      }

    var pra = [];
    //pra.push( this.state.selrow.etr01);
    var belopp = 0;
    for(var row of nta) {
        var pris = row.etr01.e0pris * 1;
        if(row.etr01.e0tkn == "-") pris = pris * (-1);
        belopp = belopp + pris
        pra.push( row.etr01);
    }

    if(belopp == 0) {
        alert("Inget att betala");
        return;
    }
    belopp = belopp.toString();
    //alert("belopp");

    var wnds = {};
    wnds.pay = 1;
    wnds.boknr = this.state.rvo.gsb00.r0boknr;
    wnds.gso = this.state.rvo.gsb00;
    wnds.pra = pra;
    wnds.betkod = betkod;
    wnds.bettext = bettxt;
    wnds.belopp = belopp;
    wnds.cb = this.cb_pay;
    this.setState({wnds: wnds});
  }
  cb_pay(ctx, ret) {
      if(ret && (ret.ok == "000")) {

      }
      if(ctx.fkn_close) ctx.fkn_close(ctx.props.ctx);
      else ctx.props.ctx.setState({ wnds: {} });
  };
  pay_emv() {
    var self = this;

    var nta = this.state.nta;
    if(Object.keys(this.state.srow).length > 0) {
        nta = Object.values(this.state.srow);
    }

    var pra = [];
    //pra.push( this.state.selrow.etr01);
    var belopp = 0;
    for(var row of nta) {
        var pris = (row.etr01.e0antal * 1) * (row.etr01.e0pris * 1);
        if(row.etr01.e0tkn == "-") pris = pris * (-1);
        belopp = belopp + pris
        pra.push( row.etr01);
    }

    if(belopp == 0) {
        alert("Inget att betala");
        return;
    }
    belopp = belopp.toString();

    var wnds = {};
    wnds.emv = 1;
    wnds.boknr = this.state.rvo.gsb00.r0boknr;
    wnds.gso = this.state.rvo.gsb00;
    wnds.pra = pra;
    wnds.belopp = belopp;
    wnds.cb = this.cb_payemv;
    this.setState({wnds: wnds});
  };

  cb_payemv(ctx, ret) {
      if(ret && (ret.ok == "000")) {

      }
      if(ctx.fkn_close) ctx.fkn_close(ctx.props.ctx);
      else ctx.props.ctx.setState({ wnds: {} });
  };
   pay_pres() {
       var self = this;

       var nta = this.state.nta;
       if(Object.keys(this.state.srow).length > 0) {
           nta = Object.values(this.state.srow);
       }

       var pra = [];
       //pra.push( this.state.selrow.etr01);
       var belopp = 0;
       for(var row of nta) {
           var pris = (row.etr01.e0antal * 1) * (row.etr01.e0pris * 1);
           if(row.etr01.e0tkn == "-") pris = pris * (-1);
           belopp = belopp + pris
           pra.push( row.etr01);
       }

       if(belopp == 0) {
           alert("Inget att betala");
           return;
       }
       belopp = belopp.toString();

        var wnds = {};
        wnds.paypres = 1;
       wnds.boknr = this.state.rvo.gsb00.r0boknr;
       wnds.gso = this.state.rvo.gsb00;
       wnds.pra = pra;
       wnds.belopp = belopp;
        wnds.cb = this.cb_pay_pres;
        this.setState({wnds: wnds});
    }
    
    cb_pay_pres(ctx, ret) {
        if(ret && (ret.ok == "000")) {

        }
        if(ctx.fkn_close) ctx.fkn_close(ctx.props.ctx);
        else ctx.props.ctx.setState({ wnds: {} });
    }
    pay_fsk() {
        var self = this;

        var nta = this.state.nta;
        if(Object.keys(this.state.srow).length > 0) {
            nta = Object.values(this.state.srow);
        }

        var pra = [];
        //pra.push( this.state.selrow.etr01);
        var belopp = 0;
        for(var row of nta) {
            var pris = (row.etr01.e0antal * 1) * (row.etr01.e0pris * 1);
            if(row.etr01.e0tkn == "-") pris = pris * (-1);
            belopp = belopp + pris
            pra.push( row.etr01);
        }

        if(belopp == 0) {
            alert("Inget att betala");
            return;
        }
        belopp = belopp.toString();

        var wnds = {};
        wnds.payfsk = 1;
        wnds.boknr = this.state.rvo.gsb00.r0boknr;
        wnds.gso = this.state.rvo.gsb00;
        wnds.pra = pra;
        wnds.belopp = belopp;
        wnds.cb = this.cb_pay_fsk;
        this.setState({wnds: wnds});
    }
    cb_pay_fsk(ctx, ret) {
        if(ret && (ret.ok == "000")) {

        }
        if(ctx.fkn_close) ctx.fkn_close(ctx.props.ctx);
        else ctx.props.ctx.setState({ wnds: {} });
    }

    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
  sz() {
  }
  val_date(val) {
      var ret = "";
      if(val) ret = val.toString().cdidate();
      return ret;
  }
  showLang() {
    var langtxt = "Svenska";
    if(this.state.lang == "en") langtxt = "Engelska";
    return langtxt;
}
set_lang() {
    var lang = this.state.lang;
    if(lang == "en") lang = "se";
    else lang = "en";
    this.setState({lang: lang});
  }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="m2_backdrop" /> : null }
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() }>
        <div className="flex-row " style={{padding:"0px",height:"50px",lineHeight:"50px", background: "#1a456b", color: "#fff"}}>
                <div className="flex-row flex" style={{padding:"0px 5px", fontSize: "22px"}}>
                    <div>BETAL VAL { this.state.rumsnr }</div>
                </div>
            <div className="wnd-close-btn" onClick={() => this.wnd_close() }>X</div>
        </div>
        <div className="mx_content flex">

        <div className="web-col flex" style={{padding: "0px"}}>

        <div id="payrowsTable" className="flex">
          <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th>Datum</th>
                <th>T</th>
                <th>Typ</th>
                <th>Text</th>
                <th>Antal</th>
                <th>Pris</th>
                <th>Summa</th>
                <th>Tecken</th>
                <th>Löpnr</th>
                <th></th>
            </tr>
            </thead>
        </table>
        <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover tb">
            <tbody>
            { this.state.nta.map((row, key) =>
            <tr key={key} style={ this.row_style(row) } onClick={ () => this.sel_row(row) }>
                <td>{ this.val_date( row.etr01.e0datum ) }</td>
                <td>{ row.etr01.e0bastyp }</td>
                <td>{ row.etr01.e0typ }</td>
                <td>{ row.etr01.e0text.toswe() }</td>
                <td className="text-center">{ row.etr01.e0antal.ztrim() }</td>
                <td className="text-right">{ row.etr01.e0pris.cdipris() }</td>
                <td className="text-right">{ ((row.etr01.e0antal * 1) * (row.etr01.e0pris * 1)).cdipris() }</td>
                <td>{ row.etr01.e0tkn }</td>
                <td>{ row.etr01.e0lopnr.ztrim() }</td>
                <td>
                    <Td_Sel items={ this.rowitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
        </div>

        <div className="flex-row px-2">
            <div className="web-link" onClick={() => this.clear() }>Rensa</div>
            <div className="flex"></div>
            <div className="web-link" onClick={() => this.set_lang() }>{ this.showLang() }</div>
            <div className="flex"></div>
            <div className="web-link" onClick={() => this.set_all() }>Välj alla</div>
        </div>
        <div className="divider_orange"></div>

        <div className="web-row">
        <div className="web-col flex">
            <div className="wnd-btn" onClick={() => this.wnd_close() } >
                <div>STÄNG</div>
                <div></div>
            </div>
        </div>
        <div className="web-col flex">
            <div className="wnd-btn" onClick={() => this.pay_trs("fakt") } >
                <div>FAKTURA</div>
                <div></div>
            </div>
            <div className="wnd-btn" onClick={() => this.pay_trs("card") } >
                <div>KORT EXTERN</div>
                <div></div>
            </div>
        </div>
         <div className="web-col flex" style={{padding: "0px 10px"}}>
            <div className="wnd-btn" onClick={() => this.pay_trs("swis") } >
                <div>SWISH</div>
                <div></div>
            </div>
            <div className="wnd-btn" onClick={() => this.pay_trs("Rpri") } >
                <div>PRESENTKORT</div>
                <div></div>
            </div>
       </div>
         <div className="web-col flex" style={{padding: "0px 10px"}}>
         <div className="wnd-btn" onClick={() => this.pay_trs("fskU") } >
                <div>FÖRSKOTT UTNYTTJA</div>
                <div></div>
            </div>
            <div className="wnd-btn" onClick={() => this.pay_trs("bg") } >
                <div>BANKGIRO</div>
                <div></div>
            </div>
       </div>
         <div className="web-col flex" style={{padding: "0px 10px"}}>
            <div className="wnd-btn" onClick={() => this.pay_trs("emv") } >
                <div>EMV KORT</div>
                <div></div>
            </div>
            <div className="wnd-btn" onClick={() => this.pay_trs("kont") } >
                <div>KONTANT</div>
                <div></div>
            </div>
       </div>
       </div>

        </div>

        </div>
      </div>
            { this.state.wnds.pay ? <Pay_Wnd wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
            { this.state.wnds.emv ? <Pay_Emv wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
            { this.state.wnds.paypres ? <Pay_Pres wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
            { this.state.wnds.payfsk ? <Pay_Fsk wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
    </div>
	;
	return html;
  };
}

export default Pay_Sel;